import React from 'react';
import styled from '@emotion/styled';

const Button = styled.button(({ theme, active, width, height, disabled }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: width || '100%',
  height: height || '100%',
  background: active ? theme.color.base_purple : theme.color.base_gray,
  borderRadius: '1.5rem',
  cursor: disabled ? 'default' : 'pointer',
}));

const PrimaryButton = ({ type = 'button', disabled, onClick, width, height, children }) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      active={!disabled}
      width={width}
      height={height}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
